/**
 * src/data/OfficeEtiquetteBank.js
 * Hardcoded scenario bank for Part 10: Unwritten Etiquette.
 */
export const officeEtiquetteBank = [
  {
    "id": 1,
    "text": "CC'ing your peer's manager on an email to politely ask the peer why they missed yesterday's deadline.",
    "correctId": "A",
    "feedback": "CLM. Weaponizing the CC line to tattle to a manager destroys horizontal peer trust. Resolve it 1-on-1 first."
  },
  {
    "id": 2,
    "text": "Fixing a peer's structural code error silently yourself and pushing the commit to ensure the sprint isn't delayed.",
    "correctId": "A",
    "feedback": "CLM. Silently masking a peer's error removes systemic accountability, prevents their professional growth, and obscures root-cause analysis from the team."
  },
  {
    "id": 3,
    "text": "DMing a peer privately with the exact fix for their code error so they can push the commit under their own name.",
    "correctId": "B",
    "feedback": "Pro Move. Shielding a peer from public failure while allowing them to maintain ownership builds massive horizontal trust and psychological safety."
  },
  {
    "id": 4,
    "text": "Answering an executive's specific metric question in a town hall by estimating a slightly inflated number to avoid looking unprepared.",
    "correctId": "A",
    "feedback": "CLM. Bluffing inaccurate data to senior leadership breaches executive trust and can cascade into catastrophic strategic misallocations."
  },
  {
    "id": 5,
    "text": "Answering an executive's specific metric question in a town hall by stating, 'I don't have the exact figure in front of me, but I will slack you the data by 2 PM.'",
    "correctId": "B",
    "feedback": "Pro Move. Demonstrates extreme ownership and intellectual honesty. Executives heavily prefer deferred accuracy over confident but risky approximations."
  },
  {
    "id": 6,
    "text": "Scheduling a private 15-minute 'pre-wire' alignment call with a known detractor the day before a high-stakes proposal pitch.",
    "correctId": "B",
    "feedback": "Pro Move. Securing buy-in and neutralizing objections privately before a public forum prevents derailing the pitch and isolates remaining dissent."
  },
  {
    "id": 7,
    "text": "Pitching a massive operational overhaul in an all-hands meeting without consulting the specific department leads it will impact first.",
    "correctId": "A",
    "feedback": "CLM. Publicly ambushing lateral leaders triggers defensive entrenchment and creates organizational enemies. Complex cross-functional changes require private pre-alignment."
  },
  {
    "id": 8,
    "text": "Taking full public responsibility for a junior report's data error in an executive review, then coaching the report privately afterward.",
    "correctId": "B",
    "feedback": "Pro Move. Secure leaders absorb blame publicly and coach privately. Shielding juniors from executive crossfire creates deep psychological safety and extreme team loyalty."
  },
  {
    "id": 9,
    "text": "Forwarding an old email thread to a cross-functional partner with 'As per my previous email' highlighted to prove you warned them about a failure.",
    "correctId": "A",
    "feedback": "CLM. Ego-driven posturing. Focusing on absolving yourself of blame rather than offering a forward-looking solution alienates stakeholders and signals low collaborative maturity."
  },
  {
    "id": 10,
    "text": "Pasting a 3-bullet BLUF (Bottom Line Up Front) summary of your 15-page analytical report directly into the email body, with the full PDF attached.",
    "correctId": "B",
    "feedback": "Pro Move. Respects executive bandwidth. Synthesizing complex data into immediate, actionable insights upfront accelerates decision-making and reduces cognitive load."
  },
  {
    "id": 11,
    "text": "Drafting a detailed project update at 11:30 PM on a Saturday, but using the 'Schedule Send' feature so it arrives in your team's inbox at 8:00 AM on Monday.",
    "correctId": "B",
    "feedback": "Pro Move. Protects team bandwidth and enforces a culture of psychological safety around downtime, while still accommodating your own asynchronous deep-work habits."
  },
  {
    "id": 12,
    "text": "Sending a detailed project update via Slack to your direct reports at 11:30 PM on a Saturday to model a strong, dedicated work ethic.",
    "correctId": "A",
    "feedback": "CLM. Off-hours messaging from authority figures creates unwritten pressure to respond, deteriorating boundary trust, spiking anxiety, and accelerating team burnout."
  },
  {
    "id": 13,
    "text": "Declining a vague calendar invite from a lateral peer and professionally requesting an agenda or required outcome before you commit to attending.",
    "correctId": "B",
    "feedback": "Pro Move. Defends your bandwidth and enforces meeting hygiene professionally, framing your pushback as a collaborative desire to be highly effective."
  },
  {
    "id": 14,
    "text": "Replying to a highly critical, multi-paragraph email from a frustrated stakeholder with a defensive, point-by-point written rebuttal to set the record straight.",
    "correctId": "A",
    "feedback": "CLM. Engaging in text-based combat escalates emotional friction and creates a permanent, forwardable paper trail of dysfunction. Move to voice or video."
  },
  {
    "id": 15,
    "text": "Drafting a 'ghost response' for your overwhelmed manager to send to a demanding stakeholder, leaving blanks for their final approval.",
    "correctId": "B",
    "feedback": "Pro Move. Anticipating a bottleneck and reducing your manager's cognitive load is elite 'managing up' that accelerates enterprise decision-making."
  },
  {
    "id": 16,
    "text": "Bypassing your direct manager to pitch a 'game-changing' efficiency idea directly to the CEO at a company networking mixer.",
    "correctId": "A",
    "feedback": "CLM. Recklessly violating the chain of command blindsides your manager. Leadership will view you as politically volatile and untrustworthy rather than innovative."
  },
  {
    "id": 17,
    "text": "Proactively documenting standard operating procedures (SOPs) for your specific workflows so anyone can cover your desk seamlessly if you take PTO.",
    "correctId": "B",
    "feedback": "Pro Move. Creating systemic redundancy shows you are ready to scale to the next level of management and promotes resilient enterprise operations by eliminating single points of failure."
  },
  {
    "id": 18,
    "text": "Hitting 'Reply All' to correct a minor, non-material typo in a senior director's department-wide email.",
    "correctId": "A",
    "feedback": "CLM. Publicly correcting senior leadership over immaterial details reads as pedantic and politically tone-deaf, offering zero ROI while damaging executive trust."
  },
  {
    "id": 19,
    "text": "Spotting a minor, non-material typo in a senior director's department-wide email and ignoring it because it does not alter the strategic message.",
    "correctId": "B",
    "feedback": "Pro Move. Exercising restraint over trivial errors preserves leadership dignity and prevents unnecessary noise in enterprise communication channels."
  },
  {
    "id": 20,
    "text": "Accepting a massive, unbudgeted project from an executive sponsor with a simple 'We'll get it done' without checking your team's capacity.",
    "correctId": "A",
    "feedback": "CLM. Blindly absorbing scope creep to appease leadership destroys team morale and guarantees eventual delivery failure, severely damaging your operational reliability."
  },
  {
    "id": 21,
    "text": "Responding to an unbudgeted executive request with: 'We can deliver this by Friday, but we will need to pause Project X. How would you like us to prioritize?'",
    "correctId": "B",
    "feedback": "Pro Move. Framing unbudgeted requests as resource trade-offs forces leadership to actively prioritize constraints, protecting your team while remaining highly strategic."
  },
  {
    "id": 22,
    "text": "Delivering harsh constructive feedback to a peer in a group Slack channel under the guise of 'radical transparency'.",
    "correctId": "A",
    "feedback": "CLM. Weaponized transparency is merely public shaming. Criticizing peers in public forums triggers defensive posturing and destroys psychological safety."
  },
  {
    "id": 23,
    "text": "Delivering constructive feedback to a peer on a private 1-on-1 video call, focusing strictly on the business impact rather than personal traits.",
    "correctId": "B",
    "feedback": "Pro Move. 'Praise in public, critique in private.' Focusing on systemic outcomes in a secure environment neutralizes defensiveness and builds robust peer trust."
  },
  {
    "id": 24,
    "text": "Answering an executive's question in a review with a simple 'I don't know' and waiting in silence for them to suggest a path forward.",
    "correctId": "A",
    "feedback": "CLM. Abdicating intellectual momentum to a senior leader drains their bandwidth. It signals a lack of resourcefulness and a passive approach to problem-solving."
  },
  {
    "id": 25,
    "text": "Answering an executive's question by stating, 'I don't have that exact cohort breakdown right now, but I will pull the query and send it to you by 3 PM.'",
    "correctId": "B",
    "feedback": "Pro Move. Exhibits high integrity and extreme ownership. Executives trust leaders who refuse to guess but immediately commit to closing the intelligence gap."
  },
  {
    "id": 26,
    "text": "Sending an 'urgent' Slack message to a peer whose calendar clearly shows they are on PTO, assuming they will simply ignore it if they are busy.",
    "correctId": "A",
    "feedback": "CLM. Disregarding documented out-of-office boundaries creates unwritten pressure to check in on PTO, degrading enterprise culture and accelerating burnout."
  },
  {
    "id": 27,
    "text": "Using 'Schedule Send' to delay a non-urgent strategic request to a peer currently on PTO until 9:00 AM on the day they return.",
    "correctId": "B",
    "feedback": "Pro Move. Respects boundaries and protects team bandwidth. Asynchronous discipline signals high operational maturity and deep respect for peers."
  },
  {
    "id": 28,
    "text": "Presenting the results of a deeply collaborative cross-functional initiative using 'I' and 'My' instead of 'We' and 'Our' to ensure you secure a promotion.",
    "correctId": "A",
    "feedback": "CLM. Credit hoarding is instantly recognizable by senior leadership and alienates lateral peers, destroying the alliances needed for future cross-functional execution."
  },
  {
    "id": 29,
    "text": "Pausing a high-visibility presentation to explicitly highlight a junior analyst's foundational data work when an executive praises the strategy.",
    "correctId": "B",
    "feedback": "Pro Move. Pushing credit downward in high-visibility settings costs you nothing, builds massive loyalty, and signals deep security in your own leadership."
  },
  {
    "id": 30,
    "text": "Hoarding access to a niche corporate software tool so that other teams must rely on you to run their specialized data reports.",
    "correctId": "A",
    "feedback": "CLM. Creating artificial operational dependencies for job security signals low collaborative maturity and actively throttles the velocity of the wider enterprise."
  },
  {
    "id": 31,
    "text": "Proactively recording a 5-minute tutorial on a complex workflow and open-sourcing it to the department so anyone can execute the task.",
    "correctId": "B",
    "feedback": "Pro Move. Building systemic resilience demonstrates you are ready for management. Democratizing knowledge frees your bandwidth to scale to higher-level strategic problems."
  },
  {
    "id": 32,
    "text": "Sending a Slack message to a busy principal engineer that just says 'Hi' and waiting for them to reply before stating your actual request.",
    "correctId": "A",
    "feedback": "CLM. Violates the unwritten 'No Hello' rule. Forcing a synchronous context switch without providing the request wastes senior bandwidth and creates cognitive friction."
  },
  {
    "id": 33,
    "text": "Including your full context, the specific request, and the urgency level in your initial Slack ping to a busy cross-functional stakeholder.",
    "correctId": "B",
    "feedback": "Pro Move. Respects asynchronous workflows. Providing all variables upfront reduces round-trip communication delays and drastically accelerates resolution time."
  },
  {
    "id": 34,
    "text": "Forwarding a complex systemic issue to your Director with the single question: 'How do you want me to handle this?'",
    "correctId": "A",
    "feedback": "CLM. Upward delegation of cognitive labor. Presenting problems without solutions trains your manager to view you as an operational burden rather than an autonomous leader."
  },
  {
    "id": 35,
    "text": "Forwarding a complex systemic issue to your Director with a breakdown of the root cause, three viable solutions, and your specific recommendation.",
    "correctId": "B",
    "feedback": "Pro Move. Downward execution and upward strategic framing. Presenting vetted solutions drastically reduces executive cognitive load and positions you as a highly autonomous leader."
  },
  {
    "id": 36,
    "text": "Reclaiming control of a derailed meeting by loudly talking over a dominant cross-functional peer to assert your authority over the agenda.",
    "correctId": "A",
    "feedback": "CLM. Engaging in vocal power struggles signals emotional volatility and damages long-term lateral relationships. Assertiveness must remain professionally composed."
  },
  {
    "id": 37,
    "text": "Reclaiming control of a derailed meeting by validating the interjector's point and placing it in a visible 'parking lot' document to preserve the core agenda.",
    "correctId": "B",
    "feedback": "Pro Move. De-escalates ego dynamically while rigorously enforcing meeting hygiene. It acknowledges the peer's contribution without sacrificing the meeting's ROI."
  },
  {
    "id": 38,
    "text": "Blocking a peer's urgent deliverable two hours before a deadline by submitting 20 pedantic, stylistic critique comments that do not affect the core functionality.",
    "correctId": "A",
    "feedback": "CLM. Prioritizing subjective perfection over business continuity demonstrates a lack of operational pragmatism and deteriorates horizontal goodwill."
  },
  {
    "id": 39,
    "text": "Approving a peer's urgent, functionally sound deliverable to meet the deadline, but scheduling a follow-up sync to discuss stylistic refactoring for future iterations.",
    "correctId": "B",
    "feedback": "Pro Move. Balances enterprise velocity with quality standards. Securing the immediate business objective while planning for technical debt reduction shows mature prioritization."
  },
  {
    "id": 40,
    "text": "Rejecting a request for a new cross-functional workstream during a live executive meeting by flatly stating, 'That falls outside of my job description.'",
    "correctId": "A",
    "feedback": "CLM. Rigid, defensive phrasing signals low adaptability and a siloed mindset. It makes you appear uncooperative in front of strategic leadership."
  },
  {
    "id": 41,
    "text": "Navigating a vague new workstream request in a live meeting by asking, 'Who is the ultimate DRI (Directly Responsible Individual) for this, so my team can align with them?'",
    "correctId": "B",
    "feedback": "Pro Move. Politely forces structural accountability. By requesting a DRI, you avoid absorbing orphan tasks while maintaining a highly collaborative, systemic posture."
  },
  {
    "id": 42,
    "text": "Realizing you accidentally dropped a critical production database table and quietly trying to restore it yourself for 45 minutes before notifying anyone.",
    "correctId": "A",
    "feedback": "CLM. Masking critical failures compounds enterprise risk. The delay in incident response can escalate a localized error into a catastrophic financial loss."
  },
  {
    "id": 43,
    "text": "Immediately messaging the engineering incident channel: 'I made a structural error on the production database. Here is the exact command I ran. Standing by for remediation.'",
    "correctId": "B",
    "feedback": "Pro Move. Radical transparency during a crisis. Suppressing ego to accelerate enterprise incident response builds legendary trust with engineering and leadership."
  },
  {
    "id": 44,
    "text": "Explaining a technical delay to the VP of Sales using deep, unmitigated engineering jargon to prove the complexity of the problem.",
    "correctId": "A",
    "feedback": "CLM. Using technical jargon to obscure reality or intimidate non-technical stakeholders is insecure and destroys cross-functional alignment."
  },
  {
    "id": 45,
    "text": "Translating a complex backend engineering delay for the VP of Sales into direct business impact, specifying exactly how it affects client onboarding timelines.",
    "correctId": "B",
    "feedback": "Pro Move. Bridging the gap between technical constraints and business realities is a rare, elite skill that drastically accelerates your path to executive leadership."
  },
  {
    "id": 46,
    "text": "Leaving behind highly generic, automated handover documentation during your two-week notice period, intentionally omitting the 'unwritten' political nuances of your role.",
    "correctId": "A",
    "feedback": "CLM. Burning institutional bridges on your way out destroys your long-term industry reputation. Your final two weeks permanently cement your professional legacy."
  },
  {
    "id": 47,
    "text": "Drafting a highly tactical 'Triage Guide' for your successor during your two-week notice, including known political landmines and undocumented workflow workarounds.",
    "correctId": "B",
    "feedback": "Pro Move. Displays supreme professional integrity. Ensuring the enterprise remains resilient even in your absence guarantees you elite references and alumni networking power."
  },
  {
    "id": 48,
    "text": "Finding yourself in an elevator with the CEO and using the 30 seconds to pitch a personal grievance about your current salary band.",
    "correctId": "A",
    "feedback": "CLM. Ambushing an executive with localized, self-serving complaints demonstrates severe lack of political intelligence and spatial awareness."
  },
  {
    "id": 49,
    "text": "Finding yourself in an elevator with the CEO and delivering a 30-second summary of a recent team win, tying it directly to the company's Q3 OKRs.",
    "correctId": "B",
    "feedback": "Pro Move. Capitalizing on informal executive exposure by highlighting team success and aligning with macro-strategy leaves a potent, positive leadership impression."
  },
  {
    "id": 50,
    "text": "Visibly clearing your email inbox and typing loudly on your laptop while sitting in the front row of a lateral peer's quarterly strategy presentation.",
    "correctId": "A",
    "feedback": "CLM. Blatant multitasking during peer presentations signals deep disrespect. It creates a toxic culture of disengagement and ensures they will not support your future initiatives."
  }
];